import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, inject, AfterViewInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DesvioDTO } from '@modulos/home/submodulos/dados-meteorologicos/interfaces/desvioDTO';
import {
	alinharDado,
	baixarEAbrirPDF,
	isNuloOuUndefined,
	numberToBrNumberTables,
	obter_erro_request,
	verificaSePDFEAdicionaNaTabela,
} from '@utils';
import { VariavelMeteorologica } from '@utils/interpolacao/intepolacao-parametros';
import {
	criarCanvasInterpolacao,
	InterpolacaoCanvasBounds,
	ValorDesvioInterpolacao,
} from '@utils/interpolacao/interpolacao';
import { GeoJsonObject, Polygon } from 'geojson';
import { ToastrService } from 'ngx-toastr';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS,
} from '../../../interfaces/tipos-relatorios';
import { RelatoriosService } from '../../../services/relatorios.service';
import * as pdfseira from '@utils/pdf-seira';
import html2canvas from 'html2canvas';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { DocumentExporter } from '@utils/document-exporter';
import * as ExcelTable from 'mr-excel';
import { DateTimeUtils } from '@utils/datetime-util';
import moment from 'moment';
import { corrigeDuplicacaoNome } from '../../../utils';
import { subDays } from 'date-fns';
import { MapaInterpolacaoComponent } from '../../../submodulos/monitoramento/pages/variaveis/componentes/mapa-interpolacao/mapa-interpolacao.component';
import {
	legendaInfoDesvioMilimetro,
	legendaInfoDesvioPorcentagem,
} from '@componentes/mapa-paraiba-svg/legenda';
import { NumberUtils } from '@utils/number-utils';
import * as Leaflet from 'leaflet';
import Position = GeoJSON.Position;
import FeatureCollection = GeoJSON.FeatureCollection;

type MapCapture = {
	dataUrl: string;
	mapRect: { x: number; y: number; w: number; h: number };
	canvasW: number;
	canvasH: number;
};

@Component({
	selector: 'seira-mapa-desvio',
	templateUrl: './mapa-desvio.component.html',
	styleUrls: ['./mapa-desvio.component.scss'],
})
export class MapaDesvioComponent implements OnInit, OnDestroy, AfterViewInit {
	inputs = inject(INPUTS_RELATORIOS);
	regiao?: Position[][];
	carregando = true;
	mapa: MapaInterpolacaoComponent;
	@ViewChild(MapaInterpolacaoComponent, { static: false })
	set mapaInterpolacao(mapa: MapaInterpolacaoComponent) {
		if (mapa) {
			this.mapa = mapa;

			setTimeout(() => this.instalarOverlaysNoMapa(), 0);
		}
	}
	medicoes: DesvioDTO[] = [];
	valoresDesvio: DesvioDTO[] = [];
	interpolacaoDesvio!: InterpolacaoCanvasBounds;
	colorJsonInterpolacao = '#5a5e66';
	weight = 1;
	tipoDesvio: keyof DesvioDTO = 'desvioMilimetro';
	unidade = '(mm)';
	legenda: Record<number, string>;
	private leafletMap?: Leaflet.Map;
	private isExporting = false;
	private readonly exportScale = 2;
	private pbGeo?: GeoJsonObject;
	maskLayer?: Leaflet.Polygon;
	private maskPaneName = 'maskPane';
	private outlineLayer?: Leaflet.GeoJSON;
	private contornoPaneName = 'contornoPane';
	private coordOverlayEl?: HTMLDivElement;
	private coordOverlayCleanup?: () => void;
	private compassOverlayEl?: HTMLDivElement;
	private compassOverlayCleanup?: () => void;
	private readonly exportDesktopWidth = 993;
	private readonly exportMobileLegendScale = 0.9;
	private readonly exportMobileLegendRaise = 10;
	private readonly exportMobileLegendBottomCut = 16;
	private readonly coordenadasRef = {
		eixoVertical: [
			{ lat: -5.9, label: '6.0° S' },
			{ lat: -6.5, label: '6,5° S' },
			{ lat: -7.0, label: '7,0° S' },
			{ lat: -7.5, label: '7,5° S' },
			{ lat: -8.0, label: '8,0° S' },
			{ lat: -8.4, label: '' },
		],
		eixoHorizontal: [
			{ lng: -38.5, label: '38,5° W' },
			{ lng: -38.0, label: '38,0° W' },
			{ lng: -37.5, label: '37.5° W' },
			{ lng: -37.0, label: '37,0° W' },
			{ lng: -36.5, label: '36,5° W' },
			{ lng: -36.0, label: '36,0° W' },
			{ lng: -35.5, label: '35,5° W' },
			{ lng: -35.0, label: '35,0° W' },
		],
	};

	descricaoRelatorio = '';
	descricaoRelatorioMilimetro =
		'Define-se como desvio (mm), a diferença entre a pluviometria registrada e a sua climatologia para um mesmo período, em um determinado local ou região.';
	descricaoRelatorioPorcentagem =
		'Define-se como desvio (%), a variação da pluviometria em relação à climatologia, expresso em porcentagem, indicando se o acumulado de chuva foi superior ou inferior à climatologia.';
	periodoTitulo = '';

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.png',
			size: 'small',
			icon: 'ph-image',
			onClick: async () => {
				try {
					this.mapa?.resetMapView();
				} catch {}
				await this.exportarPNG(
					`Desvios ${
						this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'
					} - ${this.periodoTitulo}`,
					250
				);
			},
		},

		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			activeFakeLoading: true,
			onClick: () => {
				if (this.mapa) {
					this.mapa.resetMapView();
				}
				setTimeout(() => {
					return this.exportarPDF();
				}, 1000);
			},
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];

	constructor(
		private httpClient: HttpClient,
		private relatoriosService: RelatoriosService,
		private toastr: ToastrService
	) {
		this.setValidators();
	}

	ngOnInit(): void {
		this.sincronizarTipoDesvioComFormulario();
		this.initialValues();
	}

	ngOnDestroy(): void {
		this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_INICIO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.clearValidators();
		this.removerOverlaysDaExportacao();
		if (this.outlineLayer) {
			this.outlineLayer.remove();
			this.outlineLayer = undefined;
		}
	}

	ngAfterViewInit(): void {
		this.instalarOverlaysNoMapa();
	}

	onMapReady(map: Leaflet.Map) {
		this.leafletMap = map;
		map.attributionControl?.remove();
		this.instalarOverlaysNoMapa();
	}

	private instalarOverlaysNoMapa() {
		const map = this.getLeafletMap();
		if (!map) return;

		map.whenReady(() => {
			this.aplicarContornoDaParaiba();
		});
	}

	setValidators(): void {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.setValidators(Validators.required);
	}

	initialValues() {
		const hoje = new Date();
		const umMesAtras = subDays(hoje, 30);
		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.setValue(moment(umMesAtras));
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.setValue(moment(hoje));
		const pbGeoJsonObservable = this.httpClient.get<FeatureCollection>(
			'assets/geoJson/pb-geo.json'
		);
		pbGeoJsonObservable.subscribe(value => {
			this.pbGeo = value as unknown as GeoJsonObject;
			this.regiao = (<Polygon>value.features[0].geometry)
				.coordinates as Position[][];
			this.instalarOverlaysNoMapa();
		});
	}

	getFormItemValue<T>(formValue: string): T {
		return this.inputs.form.get(formValue)!.value;
	}

	atualizaLegenda(): void {
		if (this.tipoDesvio === 'desvioMilimetro') {
			this.legenda = legendaInfoDesvioMilimetro;
		} else {
			this.legenda = legendaInfoDesvioPorcentagem;
		}
	}

	sincronizarTipoDesvioComFormulario(): void {
		const tipoDesvioSemTratamento = this.inputs.form.get(
			FormularioRelatorio.TIPO
		)?.value;
		this.tipoDesvio = this.capitalizeFirtsLetterSecundWord(
			tipoDesvioSemTratamento
		) as keyof DesvioDTO;
		this.unidade = this.getDesvioUnidade(this.tipoDesvio)!;
		this.descricaoRelatorio =
			this.tipoDesvio === 'desvioMilimetro'
				? this.descricaoRelatorioMilimetro
				: this.descricaoRelatorioPorcentagem;
		this.atualizaLegenda();
	}

	gerarRelatorio() {
		this.sincronizarTipoDesvioComFormulario();

		if (this.inputs.form.invalid) {
			return;
		}

		const dataInicio = this.inputs.form.get('dataInicio')?.value;
		const dataFim = this.inputs.form.get('dataFim')?.value;

		if (!dataInicio || !dataFim) {
			return;
		}
		this.inputs.setLoading(true);
		this.carregando = true;
		this.periodoTitulo = DateTimeUtils.formatarDataPeriodo(
			dataInicio,
			dataFim,
			'diario'
		);

		this.relatoriosService
			.relatorioMapaInterpolacaoDesvioPorPosto(dataInicio, dataFim)
			.subscribe({
				next: (resp: DesvioDTO[]) => {
					const collator = new Intl.Collator('pt-BR', {
						sensitivity: 'base',
						numeric: true,
					});
					resp.sort((a: DesvioDTO, b: DesvioDTO) => {
						const nomeA = a.nome;
						const nomeB = b.nome;
						return collator.compare(nomeA, nomeB);
					});
					this.relatoriosService.atualizaVisibilidadeBotoesExportacao(resp);
					this.medicoes = resp;
				},
				error: erro => {
					this.carregando = false;
					this.inputs.setLoading(false);
					const msg_erro = obter_erro_request(erro);
					this.toastr.error(msg_erro, 'Erro ao obter informações de Desvio');
				},
				complete: () => {
					this.interpolarValores();
					this.carregando = false;
					this.inputs.setLoading(false);
				},
			});
	}

	capitalizeFirtsLetterSecundWord(input: string): string {
		const words = input.toLowerCase().split('_');
		let camelCaseString = words[0];
		for (let i = 1; i < words.length; i++) {
			camelCaseString += words[i].charAt(0).toUpperCase() + words[i].slice(1);
		}
		return camelCaseString;
	}

	async interpolarValores() {
		try {
			const [interpolacaoDesvio] = await Promise.all([
				this.criarImagemInterpolacao(this.tipoDesvio),
			]);

			this.interpolacaoDesvio = interpolacaoDesvio as InterpolacaoCanvasBounds;
		} catch (error) {
			console.error('Erro ao interpolar valores:', error);
		}
	}

	criarImagemInterpolacao(
		tipoDesvio: keyof DesvioDTO
	): Promise<InterpolacaoCanvasBounds> {
		return new Promise((resolve, reject) => {
			const interpolacao = criarCanvasInterpolacao(
				this.valoresParaInterpolacao(tipoDesvio),
				tipoDesvio as VariavelMeteorologica,
				this.regiao as number[][][],
				0.01,
				true
			);
			if (interpolacao === undefined || interpolacao === null) {
				reject(`Erro ao criar imagem de interpolação de ${tipoDesvio}.`);
			}
			resolve(interpolacao);
		});
	}

	valoresParaInterpolacao(
		tipoDesvio: keyof DesvioDTO
	): ValorDesvioInterpolacao[] {
		return this.medicoes.map(value => ({
			lat: value.latitude,
			lng: value.longitude,
			value: value[tipoDesvio] as number,
			nome: corrigeDuplicacaoNome(value.nome),
			desvio: tipoDesvio,
		}));
	}

	getDesvioUnidade(tipoDesvio: string) {
		const unidadeMap = new Map([
			['desvioMilimetro', '(mm)'],
			['desvioPorcentagem', '(%)'],
		]);
		return unidadeMap.get(tipoDesvio);
	}

	getDadosTabelaParaExportacao(dados: DesvioDTO[], isPdf: boolean): any[][] {
		const tableData: any[][] = [];

		const colunas = [
			{
				text: 'Município/Posto',
				fillColor: '#DCDCDC',
				alignment: 'center',
			},
			{
				text:
					this.tipoDesvio === 'desvioMilimetro' ? 'Desvio (mm)' : 'Desvio (%)',
				fillColor: '#DCDCDC',
				alignment: 'center',
			},
		];

		verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);

		dados.forEach((item: DesvioDTO) => {
			const nomeFormatado = corrigeDuplicacaoNome(item.nome);
			const valorDesvio =
				this.tipoDesvio === 'desvioMilimetro'
					? numberToBrNumberTables(item.desvioMilimetro, 1)
					: numberToBrNumberTables(item.desvioPorcentagem, 1);

			if (!isPdf) {
				tableData.push([nomeFormatado, valorDesvio]);
			} else {
				tableData.push([
					{
						text: nomeFormatado,
						alignment: 'left',
					},
					alinharDado(valorDesvio, isPdf),
				]);
			}
		});

		return tableData;
	}
	getDataFormatada(data: Date): string {
		return moment(data).format('DD/MM/YYYY');
	}

	private getLeafletMap(): Leaflet.Map | null {
		return this.leafletMap ?? null;
	}

	private async esperarRenderizacaoMapa() {
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => setTimeout(() => r(), 250));
	}

	async getMapImage(): Promise<MapCapture | null> {
		const root = document.getElementById('mapa-legenda');
		const map = this.getLeafletMap();

		if (!root || !map) return null;

		this.isExporting = true;
		root.classList.add('export-mode');
		const controlesParaOcultar = Array.from(
			root.querySelectorAll(
				'.leaflet-control-zoom, .leaflet-control-container .leaflet-bar, .leaflet-control-container button'
			)
		) as HTMLElement[];

		const estadosOriginais = controlesParaOcultar.map(el => ({
			el,
			display: el.style.display,
		}));

		controlesParaOcultar.forEach(el => {
			el.style.display = 'none';
		});

		this.aplicarOverlaysSomenteNaExportacao(map);
		let restoreMobileLayout: (() => void) | null = null;

		try {
			restoreMobileLayout = await this.ajustarLayoutMobileParaExportacao(
				root,
				map
			);

			await this.esperarRenderizacaoMapa();

			const canvas = await html2canvas(root, {
				useCORS: true,
				allowTaint: true,
				logging: false,
				scale: this.exportScale,
				windowWidth: this.isMobileViewport()
					? this.exportDesktopWidth
					: window.innerWidth,
			});

			const leafletEl = root.querySelector(
				'.leaflet-container'
			) as HTMLElement | null;
			if (!leafletEl) return null;

			const rootRect = root.getBoundingClientRect();
			const mapRectDom = leafletEl.getBoundingClientRect();

			return {
				dataUrl: canvas.toDataURL('image/png', 1),
				canvasW: canvas.width,
				canvasH: canvas.height,
				mapRect: {
					x: (mapRectDom.left - rootRect.left) * this.exportScale,
					y: (mapRectDom.top - rootRect.top) * this.exportScale,
					w: mapRectDom.width * this.exportScale,
					h: mapRectDom.height * this.exportScale,
				},
			};
		} finally {
			restoreMobileLayout?.();
			this.isExporting = false;
			root.classList.remove('export-mode');
			estadosOriginais.forEach(({ el, display }) => {
				el.style.display = display;
			});
			this.removerOverlaysDaExportacao();
		}
	}

	private async ajustarLayoutMobileParaExportacao(
		root: HTMLElement,
		map: Leaflet.Map
	): Promise<(() => void) | null> {
		const isMobile = this.isMobileViewport();

		const rootPrev = {
			width: root.style.width,
			minWidth: root.style.minWidth,
			maxWidth: root.style.maxWidth,
			paddingTop: root.style.paddingTop,
		};
		const legendaWrapper = root.querySelector(
			'seira-monitoramento-legenda-horizontal > .mt-10'
		) as HTMLElement | null;
		const legendaWrapperFallback = root.querySelector(
			'seira-monitoramento-legenda-horizontal .legenda-wrapper'
		) as HTMLElement | null;
		const legendaHost = root.querySelector(
			'seira-monitoramento-legenda-horizontal'
		) as HTMLElement | null;
		const leafletContainer = root.querySelector(
			'.leaflet-container'
		) as HTMLElement | null;
		const legendaAlvo = legendaWrapper ?? legendaWrapperFallback;
		const legendaWrapperPrev = legendaAlvo
			? {
					marginTop: legendaAlvo.style.marginTop,
					marginTopPriority: legendaAlvo.style.getPropertyPriority('margin-top'),
					clipPath: legendaAlvo.style.clipPath,
					transform: legendaAlvo.style.transform,
					transformOrigin: legendaAlvo.style.transformOrigin,
					position: legendaAlvo.style.position,
					zIndex: legendaAlvo.style.zIndex,
					overflow: legendaAlvo.style.overflow,
			  }
			: null;
		const legendaHostPrev = legendaHost
			? {
					position: legendaHost.style.position,
					zIndex: legendaHost.style.zIndex,
			  }
			: null;
		const leafletContainerPrev = leafletContainer
			? {
					position: leafletContainer.style.position,
					zIndex: leafletContainer.style.zIndex,
			  }
			: null;

		root.style.paddingTop = '4px';

		if (isMobile) {
			root.style.width = `${this.exportDesktopWidth}px`;
			root.style.minWidth = `${this.exportDesktopWidth}px`;
			root.style.maxWidth = `${this.exportDesktopWidth}px`;
		}

		if (legendaAlvo) {
			const legendaTranslateX = isMobile ? 40 : 34;
			legendaAlvo.style.setProperty('margin-top', '0', 'important');
			legendaAlvo.style.transform = `translate(${legendaTranslateX}px, -72px) scale(1)`;
			legendaAlvo.style.transformOrigin = 'top center';
			legendaAlvo.style.position = 'relative';
			legendaAlvo.style.zIndex = '10020';
			legendaAlvo.style.overflow = 'visible';
		}

		if (legendaHost) {
			legendaHost.style.position = 'relative';
			legendaHost.style.zIndex = '10020';
		}

		if (leafletContainer) {
			leafletContainer.style.position = 'relative';
			leafletContainer.style.zIndex = '1';
		}

		map.invalidateSize(true);
		await this.esperarRenderizacaoMapa();

		return () => {
			root.style.width = rootPrev.width;
			root.style.minWidth = rootPrev.minWidth;
			root.style.maxWidth = rootPrev.maxWidth;
			root.style.paddingTop = rootPrev.paddingTop;

			if (legendaAlvo && legendaWrapperPrev) {
				if (legendaWrapperPrev.marginTop) {
					legendaAlvo.style.setProperty(
						'margin-top',
						legendaWrapperPrev.marginTop,
						legendaWrapperPrev.marginTopPriority
					);
				} else {
					legendaAlvo.style.removeProperty('margin-top');
				}
				legendaAlvo.style.clipPath = legendaWrapperPrev.clipPath;
				legendaAlvo.style.transform = legendaWrapperPrev.transform;
				legendaAlvo.style.transformOrigin =
					legendaWrapperPrev.transformOrigin;
				legendaAlvo.style.position = legendaWrapperPrev.position;
				legendaAlvo.style.zIndex = legendaWrapperPrev.zIndex;
				legendaAlvo.style.overflow = legendaWrapperPrev.overflow;
			}

			if (legendaHost && legendaHostPrev) {
				legendaHost.style.position = legendaHostPrev.position;
				legendaHost.style.zIndex = legendaHostPrev.zIndex;
			}

			if (leafletContainer && leafletContainerPrev) {
				leafletContainer.style.position = leafletContainerPrev.position;
				leafletContainer.style.zIndex = leafletContainerPrev.zIndex;
			}

			map.invalidateSize(true);
		};
	}

	private isMobileViewport(): boolean {
		return window.innerWidth < this.exportDesktopWidth;
	}

	retornarDesviosParaXLSX() {
		const tableData: any[] = [];

		this.medicoes.map(desvio => {
			if (this.tipoDesvio === 'desvioMilimetro') {
				tableData.push({
					desvioMilimetro: isNuloOuUndefined(desvio.desvioMilimetro)
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(desvio.desvioMilimetro),
					nome: corrigeDuplicacaoNome(desvio.nome),
				});
			} else {
				tableData.push({
					desvioPorcentagem: isNuloOuUndefined(desvio.desvioPorcentagem)
						? '-'
						: NumberUtils.getIgnorandoCasasDecimais(desvio.desvioPorcentagem),
					nome: corrigeDuplicacaoNome(desvio.nome),
				});
			}
		});

		return tableData;
	}

	async exportarPDF() {
		const documentDefinition: any = await pdfseira.documentDefinitions();
		const capture = await this.getMapImage();
		if (!capture) {
			this.toastr.error('Não foi possível capturar o mapa para PDF.');
			return;
		}
		const { dataUrl } = await this.montarMapaComLogos(capture, { showHeader: false });
		const img = await this.recortarDataUrlSides(
			dataUrl,
			this.getCropRectExportacao(capture, false),
			this.getCropPaddingExportacao()
		);

		documentDefinition.content.push([
			{
				text: `Desvios ${
					this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'
				} - ${this.periodoTitulo}`,
				alignment: 'center',
				margin: [0, 6, 0, 6],
			},
			{
				image: img,
				fit: [500, 400],
				margin: [0, -8, 0, 0],
				alignment: 'center',
			},
		]);

		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, true);

		documentDefinition.content.push({
			table: {
				widths: ['50%', '50%'],
				body: tableData,
				layout: {
					noWrap: false,
					fontSize: 5,
				},
			},

			marginLeft: 15,
			marginRight: 15,
		});

		baixarEAbrirPDF(
			`Desvios ${this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'} - ${
				this.periodoTitulo
			}`,
			documentDefinition
		);
	}

	exportarCSV() {
		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, false);

		DocumentExporter.gerarCSV(
			tableData,
			`Desvios ${this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'} - ${
				this.periodoTitulo
			}`
		);
	}

	exportarTXT() {
		const tableData = this.getDadosTabelaParaExportacao(this.medicoes, false);

		let txtData = '';
		if (tableData.length > 0) {
			const colunas = tableData[0];

			tableData.slice(1).forEach(dadoRelatorio => {
				colunas.forEach((coluna: string, index: number) => {
					const valor = dadoRelatorio[index];
					txtData += `${coluna}: ${valor ?? '-'}\n`;
				});

				txtData += '\n';
			});
		}

		DocumentExporter.gerarTXT(
			txtData,
			`Desvios ${this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'} - ${
				this.periodoTitulo
			}`
		);
	}

	async exportarXLSX() {
		const nomeArquivo = `Desvios ${
			this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'
		} - ${this.periodoTitulo}`;

		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};

		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const headers = [
			{
				label: 'nome',
				text: 'Município/Posto',
				size: 48,
			},
		];

		this.tipoDesvio === 'desvioMilimetro'
			? headers.push({
					label: 'desvioMilimetro',
					text: 'Desvio (mm)',
					size: 24,
			  })
			: headers.push({
					label: 'desvioPorcentagem',
					text: 'Desvio (%)',
					size: 24,
			  });

		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleCenter,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number
					) {
						if (data && data.label) {
							return 'headerStyleCenter';
						} else {
							if (colIndex > 0) {
								return 'rowStyleCenter';
							} else {
								return 'rowStyle';
							}
						}
					},
					headers: headers,
					data: this.retornarDesviosParaXLSX(),
					columns: [
						{ key: 'municipio' },
						{
							key:
								this.tipoDesvio === 'desvioMilimetro'
									? 'desvioMilimetro'
									: 'desvioPorcentagem',
							style: { numFmt: '0.0' },
						},
					],
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: `${nomeArquivo}`,
						styleId: 'title',
					},
				},
			],
			fileName: nomeArquivo,
		};

		ExcelTable.generateExcel(dataExcel);
	}
	private downloadDataUrl(nomeArquivoSemExt: string, dataUrl: string) {
		const a = document.createElement('a');
		a.href = dataUrl;
		a.download = `${nomeArquivoSemExt}.png`;
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	public async exportarPNG(nomeArquivo?: string, delayMs = 200) {
		try {
			try {
				this.mapa?.resetMapView();
			} catch {}

			await new Promise(r => setTimeout(r, delayMs));
			const capture = await this.getMapImage();
			if (!capture) {
				this.toastr.error('Não foi possível capturar o mapa para PNG.');
				return;
			}
			const { dataUrl } = await this.montarMapaComLogos(capture);
				const finalDataUrl = await this.recortarDataUrlSides(
					dataUrl,
					this.getCropRectExportacao(capture),
					this.getCropPaddingExportacao()
				);
			const nome =
				nomeArquivo ??
				`Desvios ${this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'} - ${
					this.periodoTitulo
				}`;

			this.downloadDataUrl(nome, finalDataUrl);
		} catch (e) {
			console.error(e);
			this.toastr.error('Falha ao exportar PNG.');
		}
	}

	private resolveAsset(path: string) {
		return new URL(path, document.baseURI).toString();
	}

	private carregarImagem(src: string): Promise<HTMLImageElement> {
		return new Promise((resolve, reject) => {
			const image = new Image();
			if (!src.startsWith('data:')) {
				image.crossOrigin = 'anonymous';
			}
			image.onload = () => resolve(image);
			image.onerror = err => reject(err);
			image.src = src;
		});
	}

	private async montarMapaComLogos(
		capture: MapCapture,
		opts?: { showHeader?: boolean }
	): Promise<{ dataUrl: string }> {
		const showHeader = opts?.showHeader ?? true;
		const headerHeight = showHeader ? 172 : 0;
		const mapOffsetY = showHeader ? -18 : 0;
		const logoGovernoSrc = this.resolveAsset(
			'assets/images/logos/governo_pb.png'
		);
		const logoAesaSrc = this.resolveAsset('assets/images/logos/logoAesa.svg');

		const results = await Promise.allSettled([
			this.carregarImagem(capture.dataUrl),
			this.carregarImagem(logoGovernoSrc),
			this.carregarImagem(logoAesaSrc),
		]);

		const mapImage =
			results[0].status === 'fulfilled' ? results[0].value : null;
		const logoGov = results[1].status === 'fulfilled' ? results[1].value : null;
		const logoAesa =
			results[2].status === 'fulfilled' ? results[2].value : null;

		if (!mapImage) return { dataUrl: capture.dataUrl };

		const canvas = document.createElement('canvas');
		canvas.width = mapImage.naturalWidth;
		canvas.height = mapImage.naturalHeight + headerHeight;

		const ctx = canvas.getContext('2d')!;
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.drawImage(mapImage, 0, headerHeight + mapOffsetY);
		if (showHeader) {
			this.desenharCabecalhoExportacao(ctx, canvas.width, headerHeight);
		}

		const captureComOffset: MapCapture = {
			...capture,
			mapRect: {
				...capture.mapRect,
				y: capture.mapRect.y + headerHeight + mapOffsetY,
			},
		};

		const mapX0 = captureComOffset.mapRect.x;
		const mapY0 = captureComOffset.mapRect.y;
		const mapX1 = mapX0 + captureComOffset.mapRect.w;
		const mapY1 = mapY0 + captureComOffset.mapRect.h;
		const insidePad = 75;
		const maxLogoHInside = Math.round(
			Math.min(70, captureComOffset.mapRect.h * 0.12)
		);
		const hLogo = maxLogoHInside;

		const drawLogoInside = (imgEl: HTMLImageElement, x: number, y: number) => {
			const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
			const h = hLogo;
			const w = Math.round(h * ratio);
			ctx.drawImage(imgEl, x, y, w, h);
		};

		const govDx = -105;
		const govDy = -132;
		const aesaDx = 91;
		const aesaDy = -132;

		if (logoAesa) {
			drawLogoInside(
				logoAesa,
				mapX0 + insidePad + aesaDx,
				mapY1 - insidePad - hLogo + aesaDy
			);
		}

		if (logoGov) {
			const wG = Math.round(
				hLogo * (logoGov.naturalWidth / logoGov.naturalHeight)
			);
			drawLogoInside(
				logoGov,
				mapX1 - insidePad - wG + govDx,
				mapY1 - insidePad - hLogo + govDy
			);
		}

		return { dataUrl: canvas.toDataURL('image/png', 1) };
	}

	private desenharCabecalhoExportacao(
		ctx: CanvasRenderingContext2D,
		canvasWidth: number,
		headerHeight: number
	) {
		const titulo = `Desvios ${
			this.tipoDesvio === 'desvioMilimetro' ? '(mm)' : '(%)'
		}`;
		const periodo = this.periodoTitulo ?? '';

		ctx.save();
		ctx.fillStyle = 'rgba(255,255,255,0.96)';
		ctx.fillRect(0, 0, canvasWidth, headerHeight);

		ctx.strokeStyle = 'rgba(17,24,39,0.12)';
		ctx.lineWidth = 1;
		ctx.beginPath();
		ctx.moveTo(0, headerHeight - 0.5);
		ctx.lineTo(canvasWidth, headerHeight - 0.5);
		ctx.stroke();

		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = '#111827';

		ctx.font = '700 34px Poppins, Arial, sans-serif';
		ctx.fillText(titulo, canvasWidth / 2, 210);

		ctx.font = '600 32px Poppins, Arial, sans-serif';
		ctx.fillText(periodo, canvasWidth / 2, 250);
		ctx.restore();
	}

	private getCropRectExportacao(capture: MapCapture, showHeader = true) {
		const headerHeight = showHeader ? 172 : 0;
		const mapOffsetY = showHeader ? -18 : 0;
		const offsetY = headerHeight + mapOffsetY;

		return {
			x: capture.mapRect.x,
			y: offsetY + capture.mapRect.y,
			w: capture.mapRect.w,
			h: capture.mapRect.h,
		};
	}

	private getCropPaddingExportacao() {
		return { bottom: 65, top: -10, left: -50, right: -50 };
	}

	private async recortarDataUrlSides(
		dataUrl: string,
		rect: { x: number; y: number; w: number; h: number },
		pad: { top?: number; right?: number; bottom?: number; left?: number } = {}
	): Promise<string> {
		const img = await this.carregarImagem(dataUrl);

		const top = pad.top ?? 0;
		const right = pad.right ?? 0;
		const bottom = pad.bottom ?? 0;
		const left = pad.left ?? 0;

		const sx = Math.max(0, Math.floor(rect.x - left));
		const sy = Math.max(0, Math.floor(rect.y - top));
		const sw = Math.min(
			img.naturalWidth - sx,
			Math.floor(rect.w + left + right)
		);
		const sh = Math.min(
			img.naturalHeight - sy,
			Math.floor(rect.h + top + bottom)
		);

		const out = document.createElement('canvas');
		out.width = sw;
		out.height = sh;

		const ctx = out.getContext('2d')!;
		ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

		return out.toDataURL('image/png', 1);
	}

	private desenharCoordenadasNaExportacao(
		ctx: CanvasRenderingContext2D,
		capture: MapCapture
	) {
		const map = this.getLeafletMap();
		if (!map) return;

		const scale = this.exportScale;
		const axisX = capture.mapRect.x + 74 * scale;
		const axisTop = capture.mapRect.y + 60 * scale;
		const axisRight = capture.mapRect.x + capture.mapRect.w - 84 * scale;
		const center = map.getBounds().getCenter();
		const latBaseEixoX =
			this.coordenadasRef.eixoVertical[
				this.coordenadasRef.eixoVertical.length - 1
			]?.lat ?? -8.39;
		const yBaseRaw = map.latLngToContainerPoint([latBaseEixoX, center.lng]).y;
		const tickLen = 10 * scale;
		const maxAxisY = capture.mapRect.y + capture.mapRect.h - (tickLen + 18 * scale);
		const minAxisY = axisTop + 40 * scale;
		const axisY = Math.round(
			Math.min(maxAxisY, Math.max(minAxisY, capture.mapRect.y + yBaseRaw * scale))
		);

		ctx.save();
		ctx.strokeStyle = '#000000';
		ctx.fillStyle = '#000000';
		ctx.lineWidth = 1;

		ctx.beginPath();
		ctx.moveTo(axisX, axisTop);
		ctx.lineTo(axisX, axisY);
		ctx.moveTo(axisX, axisY);
		ctx.lineTo(axisRight, axisY);
		ctx.moveTo(axisX, axisTop);
		ctx.lineTo(axisRight, axisTop);
		ctx.moveTo(axisRight, axisTop);
		ctx.lineTo(axisRight, axisY);
		ctx.stroke();

		ctx.font = `${12 * scale}px Arial`;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		this.coordenadasRef.eixoVertical.forEach(t => {
			const yRaw = map.latLngToContainerPoint([t.lat, center.lng]).y;
			const y = Math.round(
				Math.min(axisY, Math.max(axisTop, capture.mapRect.y + yRaw * scale))
			);

			ctx.beginPath();
			ctx.moveTo(axisX, y);
			ctx.lineTo(axisX + tickLen, y);
			ctx.stroke();

			ctx.save();
			ctx.translate(axisX - 18 * scale, y);
			ctx.rotate(-Math.PI / 2);
			ctx.fillText(t.label, 0, 0);
			ctx.restore();
		});

		this.coordenadasRef.eixoHorizontal.forEach(t => {
			const xRaw = map.latLngToContainerPoint([center.lat, t.lng]).x;
			const x = Math.round(
				Math.min(
					axisRight,
					Math.max(axisX, capture.mapRect.x + xRaw * scale)
				)
			);

			ctx.beginPath();
			ctx.moveTo(x, axisY - tickLen);
			ctx.lineTo(x, axisY);
			ctx.stroke();
			ctx.fillText(t.label, x, axisY + 18 * scale);
		});

		ctx.save();
		ctx.translate(axisX - 34 * scale, (axisTop + axisY) / 2);
		ctx.rotate(-Math.PI / 2);
		ctx.font = `${14 * scale}px Arial`;
		ctx.fillText('Latitude', 0, 0);
		ctx.restore();

		ctx.font = `${14 * scale}px Arial`;
		ctx.fillText('Longitude', (axisX + axisRight) / 2, axisY + 40 * scale);
		ctx.restore();
	}

	private async desenharRosaDosVentosNaExportacao(
		ctx: CanvasRenderingContext2D,
		capture: MapCapture
	) {
		const scale = this.exportScale;
		const size = 50 * scale;
		const x = capture.mapRect.x + capture.mapRect.w - 164 * scale;
		const y = capture.mapRect.y + 90 * scale;
		try {
			const svg = this.getRosaDosVentosSvg(Math.round(size));
			const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
			const rosaDosVentos = await this.carregarImagem(svgUrl);
			ctx.drawImage(rosaDosVentos, x, y, size, size);
		} catch {
			this.desenharRosaDosVentosFallback(ctx, x, y, size);
		}
	}

	private aplicarCoordenadas(map: Leaflet.Map) {
		if (this.coordOverlayEl) this.coordOverlayEl.remove();
		if (this.coordOverlayCleanup) this.coordOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-coordenadas-overlay';
		overlay.style.position = 'absolute';
		overlay.style.inset = '0';
		overlay.style.pointerEvents = 'none';
		overlay.style.overflow = 'hidden';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.coordOverlayEl = overlay;

		const render = () => this.renderizarCoordenadasNoMapa(map);

		map.whenReady(() => render());
		map.on('resize', render);
		map.on('moveend', render);
		map.on('zoomend', render);

		this.coordOverlayCleanup = () => {
			map.off('resize', render);
			map.off('moveend', render);
			map.off('zoomend', render);
		};
	}

	private renderizarCoordenadasNoMapa(map: Leaflet.Map) {
		if (!this.coordOverlayEl) return;

		const size = map.getSize();
		if (!size || size.x < 50 || size.y < 50) return;

		const b = map.getBounds();
		const center = b.getCenter();
		const gutterLeft = 74;
		const padTop = 60;
		const padRight = 84;
		const axisX = gutterLeft;
		const axisTop = padTop;
		const axisRight = size.x - padRight;
		const latBaseEixoX =
			this.coordenadasRef.eixoVertical[
				this.coordenadasRef.eixoVertical.length - 1
			]?.lat ?? -8.39;
		const yBaseRaw = map.latLngToContainerPoint([latBaseEixoX, center.lng]).y;
		const lineColor = 'rgba(0,0,0,1)';
		const textColor = 'rgba(0,0,0,1)';
		const fontSize = 12;
		const tickLen = 10;
		const gap = 3;
		const maxAxisY = size.y - (tickLen + 18);
		const minAxisY = axisTop + 40;
		const axisY = Math.round(Math.min(maxAxisY, Math.max(minAxisY, yBaseRaw)));

		const eixoLinhas = `
			<div style="position:absolute; left:${axisX}px; top:${axisTop}px; width:1px; height:${Math.max(
				0,
				axisY - axisTop
			)}px; background:${lineColor};"></div>
			<div style="position:absolute; left:${axisX}px; top:${axisY}px; height:1px; width:${Math.max(
				0,
				axisRight - axisX
			)}px; background:${lineColor};"></div>
			<div style="position:absolute; left:${axisX}px; top:${axisTop}px; height:1px; width:${Math.max(
				0,
				axisRight - axisX
			)}px; background:${lineColor};"></div>
			<div style="position:absolute; left:${axisRight}px; top:${axisTop}px; width:1px; height:${Math.max(
				0,
				axisY - axisTop
			)}px; background:${lineColor};"></div>
		`;

		const ticksY = this.coordenadasRef.eixoVertical
			.map(t => {
				const yRaw = map.latLngToContainerPoint([t.lat, center.lng]).y;
				if (yRaw < axisTop - 80 || yRaw > axisY + 80) return '';
				const y = Math.round(Math.min(axisY, Math.max(axisTop, yRaw)));
				const xLabel = axisX - tickLen - gap;

				return `
					<div style="position:absolute; left:${xLabel}px; top:${y}px; transform: translate(-100%,-50%); color:${textColor}; font-size:${fontSize}px; line-height:1; white-space:nowrap;">
						<span style="display:inline-block; transform: rotate(-90deg); transform-origin: 100% 50%;">${t.label}</span>
					</div>
					<div style="position:absolute; left:${axisX}px; top:${y}px; width:${tickLen}px; height:1px; background:${lineColor}; transform:translateY(-50%);"></div>
				`;
			})
			.join('');

		const ticksX = this.coordenadasRef.eixoHorizontal
			.map(t => {
				const xRaw = map.latLngToContainerPoint([center.lat, t.lng]).x;
				if (xRaw < axisX - 80 || xRaw > axisRight + 80) return '';
				const x = Math.round(Math.min(axisRight, Math.max(axisX, xRaw)));

				return `
					<div style="position:absolute; left:${x}px; top:${axisY - tickLen}px; width:1px; height:${tickLen}px; background:${lineColor}; transform:translateX(-50%);"></div>
					<div style="position:absolute; left:${x}px; top:${axisY + tickLen + -5}px; transform:translateX(-50%); color:${textColor}; font-size:${fontSize}px; line-height:1; white-space:nowrap;">${t.label}</div>
				`;
			})
			.join('');

		const midY = Math.round((axisTop + axisY) / 2);
		const midX = Math.round((axisX + axisRight) / 2);

		this.coordOverlayEl.innerHTML = `
			${eixoLinhas}
			${ticksY}
			${ticksX}
			<div style="position:absolute; left:${axisX - 30}px; top:${midY}px; transform: translate(-100%,-50%) rotate(-90deg); transform-origin: 100% 50%; color:${textColor}; font-size:${fontSize + 2}px; white-space:nowrap;">Latitude</div>
			<div style="position:absolute; left:${midX}px; top:${axisY + tickLen + 12}px; transform: translateX(-50%); color:${textColor}; font-size:${fontSize + 2}px; white-space:nowrap;">Longitude</div>
		`;
	}

	private aplicarRosaDosVentos(map: Leaflet.Map) {
		if (this.compassOverlayEl) this.compassOverlayEl.remove();
		if (this.compassOverlayCleanup) this.compassOverlayCleanup();

		const container = map.getContainer() as HTMLElement;
		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		const overlay = document.createElement('div');
		overlay.className = 'mapa-rosa-ventos-overlay';
		overlay.style.position = 'absolute';
		overlay.style.right = '95px';
		overlay.style.top = '70px';
		overlay.style.left = 'auto';
		overlay.style.width = '60px';
		overlay.style.height = '60px';
		overlay.style.pointerEvents = 'none';
		overlay.style.zIndex = '9999';

		container.appendChild(overlay);
		this.compassOverlayEl = overlay;

		const render = () => this.renderizarRosaDosVentos();
		map.whenReady(() => render());
		map.on('resize', render);

		this.compassOverlayCleanup = () => {
			map.off('resize', render);
		};
	}

	private renderizarRosaDosVentos() {
		if (!this.compassOverlayEl) return;
		this.compassOverlayEl.innerHTML = this.getRosaDosVentosSvg(60);
	}

	private getRosaDosVentosSvg(size: number) {
		const preto = '#111827';
		const cinza = '#9CA3AF';

		return `
			<svg viewBox="0 0 100 100" width="${size}" height="${size}" style="display:block;">
				<circle cx="50" cy="52" r="32" fill="none" stroke="${cinza}" stroke-width="2"/>
				<polygon points="50,18 57,52 50,86 43,52" fill="${cinza}"/>
				<polygon points="18,52 50,59 82,52 50,45" fill="${cinza}"/>
				<polygon points="50,26 54,52 50,78 46,52" fill="${cinza}" opacity="0.9" transform="rotate(45 50 52)"/>
				<circle cx="50" cy="52" r="4" fill="${cinza}"/>
				<text x="50" y="10" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">N</text>
				<text x="76" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NE</text>
				<text x="24" y="22" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">NO</text>
				<text x="92" y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">L</text>
				<text x="8" y="55" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">O</text>
				<text x="76" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SE</text>
				<text x="24" y="92" text-anchor="middle" font-size="10" font-weight="700" fill="${preto}">SO</text>
				<text x="50" y="99" text-anchor="middle" font-size="11" font-weight="700" fill="${preto}">S</text>
			</svg>
		`;
	}

	private desenharRosaDosVentosFallback(
		ctx: CanvasRenderingContext2D,
		x: number,
		y: number,
		size: number
	) {
		const scale = size / 100;
		const centerX = x + size / 2;
		const centerY = y + 52 * scale;
		const r = 32 * scale;
		const cinza = '#9CA3AF';
		const preto = '#111827';

		ctx.save();
		ctx.strokeStyle = cinza;
		ctx.fillStyle = cinza;
		ctx.lineWidth = 2 * scale;

		ctx.beginPath();
		ctx.arc(centerX, centerY, r, 0, Math.PI * 2);
		ctx.stroke();

		const drawPolygon = (points: [number, number][]) => {
			ctx.beginPath();
			ctx.moveTo(points[0][0], points[0][1]);
			points.slice(1).forEach(([px, py]) => ctx.lineTo(px, py));
			ctx.closePath();
			ctx.fill();
		};

		drawPolygon([
			[centerX, y + 18 * scale],
			[centerX + 7 * scale, centerY],
			[centerX, y + 86 * scale],
			[centerX - 7 * scale, centerY],
		]);
		drawPolygon([
			[x + 18 * scale, centerY],
			[centerX, centerY + 7 * scale],
			[x + 82 * scale, centerY],
			[centerX, centerY - 7 * scale],
		]);

		ctx.save();
		ctx.globalAlpha = 0.9;
		drawPolygon([
			[centerX, y + 26 * scale],
			[centerX + 4 * scale, centerY],
			[centerX, y + 78 * scale],
			[centerX - 4 * scale, centerY],
		]);
		ctx.restore();

		ctx.beginPath();
		ctx.arc(centerX, centerY, 4 * scale, 0, Math.PI * 2);
		ctx.fill();

		ctx.fillStyle = preto;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.font = `700 ${11 * scale}px Arial`;
		ctx.fillText('N', centerX, y + 10 * scale);
		ctx.fillText('L', x + 92 * scale, centerY);
		ctx.fillText('O', x + 8 * scale, centerY);
		ctx.fillText('S', centerX, y + 99 * scale);
		ctx.font = `700 ${10 * scale}px Arial`;
		ctx.fillText('NE', x + 76 * scale, y + 22 * scale);
		ctx.fillText('NO', x + 24 * scale, y + 22 * scale);
		ctx.fillText('SE', x + 76 * scale, y + 92 * scale);
		ctx.fillText('SO', x + 24 * scale, y + 92 * scale);
		ctx.restore();
	}

	private removerCoordenadas() {
		if (this.coordOverlayEl) {
			this.coordOverlayEl.remove();
			this.coordOverlayEl = undefined;
		}

		if (this.coordOverlayCleanup) {
			this.coordOverlayCleanup();
			this.coordOverlayCleanup = undefined;
		}
	}

	private removerRosaDosVentos() {
		if (this.compassOverlayEl) {
			this.compassOverlayEl.remove();
			this.compassOverlayEl = undefined;
		}

		if (this.compassOverlayCleanup) {
			this.compassOverlayCleanup();
			this.compassOverlayCleanup = undefined;
		}
	}

	private aplicarMascaraForaDoMapa(geo: GeoJsonObject, map: Leaflet.Map) {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}

		if (!map.getPane(this.maskPaneName)) {
			map.createPane(this.maskPaneName);
			const pane = map.getPane(this.maskPaneName)!;
			pane.style.zIndex = '350';
			pane.style.pointerEvents = 'none';
		}

		const holes: Leaflet.LatLngExpression[][] = [];

		const addPolygonOuterRingAsHole = (coords: any) => {
			if (!Array.isArray(coords) || !Array.isArray(coords[0])) return;

			const ring = coords[0] as [number, number][];
			const latlngs: Leaflet.LatLngExpression[] = ring.map(([lng, lat]) => [
				lat,
				lng,
			]);
			holes.push(latlngs);
		};

		const g: any = geo;

		if (g?.type === 'FeatureCollection' && Array.isArray(g.features)) {
			for (const f of g.features) {
				const geom = f?.geometry;
				if (!geom) continue;

				if (geom.type === 'Polygon') {
					addPolygonOuterRingAsHole(geom.coordinates);
				} else if (geom.type === 'MultiPolygon') {
					for (const polyCoords of geom.coordinates) {
						addPolygonOuterRingAsHole(polyCoords);
					}
				}
			}
		}

		const outer: Leaflet.LatLngExpression[] = [
			[90, -180],
			[90, 180],
			[-90, 180],
			[-90, -180],
		];

		this.maskLayer = Leaflet.polygon([outer, ...holes], {
			pane: this.maskPaneName,
			stroke: false,
			fillColor: '#FFFFFF',
			fillOpacity: 1,
			interactive: false,
		}).addTo(map);
	}

	private aplicarContornoDaParaiba() {
		const map = this.getLeafletMap();
		if (!map || !this.pbGeo) return;

		if (!map.getPane(this.contornoPaneName)) {
			map.createPane(this.contornoPaneName);
			const pane = map.getPane(this.contornoPaneName)!;
			pane.style.zIndex = '450';
			pane.style.pointerEvents = 'none';
		}

		if (this.outlineLayer) {
			this.outlineLayer.remove();
			this.outlineLayer = undefined;
		}

		this.outlineLayer = Leaflet.geoJSON(this.pbGeo as any, {
			pane: this.contornoPaneName,
			interactive: false,
			style: () => ({
				color: '#111827',
				opacity: this.isExporting ? 0.85 : 0.7,
				weight: this.isExporting ? 1.4 : 1.0,
				fill: false,
				fillOpacity: 0,
				lineJoin: 'round',
				lineCap: 'round',
			}),
		}).addTo(map);

		this.outlineLayer.bringToFront();
	}

	private removerMascara() {
		if (this.maskLayer) {
			this.maskLayer.remove();
			this.maskLayer = undefined;
		}
	}

	private aplicarOverlaysSomenteNaExportacao(map: Leaflet.Map) {
		if (this.pbGeo) {
			this.aplicarMascaraForaDoMapa(this.pbGeo, map);
		}
		this.aplicarCoordenadas(map);
		this.aplicarRosaDosVentos(map);
		this.aplicarContornoDaParaiba();
	}

	private removerOverlaysDaExportacao() {
		this.removerMascara();
		this.removerCoordenadas();
		this.removerRosaDosVentos();
	}
}
